// SupplierDialog (Estoque Fase 2 / S64) — cadastro/edição de fornecedor.
import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button,
  FormControlLabel, Switch, CircularProgress
} from "@material-ui/core";
import { toast } from "react-toastify";
import { createStockSupplier, updateStockSupplier, financeErrorMessage } from "../../services/financeService";

const EMPTY = { name: "", cnpj: "", phone: "", email: "", notes: "", active: true };

const SupplierDialog = ({ open, supplier, onClose, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setForm(supplier ? {
        name: supplier.name || "", cnpj: supplier.cnpj || "", phone: supplier.phone || "",
        email: supplier.email || "", notes: supplier.notes || "", active: supplier.active !== false
      } : EMPTY);
    }
  }, [open, supplier]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSave = async () => {
    if (!form.name.trim()) { toast.warn("Informe o nome do fornecedor."); return; }
    setSaving(true);
    try {
      if (supplier && supplier.id) await updateStockSupplier(supplier.id, form);
      else await createStockSupplier(form);
      toast.success("Fornecedor salvo.");
      if (onSaved) onSaved();
      onClose();
    } catch (e) {
      toast.error(financeErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => (!saving ? onClose() : null)} maxWidth="sm" fullWidth>
      <DialogTitle>{supplier && supplier.id ? "Editar fornecedor" : "Novo fornecedor"}</DialogTitle>
      <DialogContent>
        <TextField label="Nome *" value={form.name} onChange={set("name")} fullWidth variant="outlined" size="small" margin="dense" autoFocus />
        <TextField label="CNPJ" value={form.cnpj} onChange={set("cnpj")} fullWidth variant="outlined" size="small" margin="dense" />
        <TextField label="Telefone" value={form.phone} onChange={set("phone")} fullWidth variant="outlined" size="small" margin="dense" />
        <TextField label="E-mail" value={form.email} onChange={set("email")} fullWidth variant="outlined" size="small" margin="dense" />
        <TextField label="Observações" value={form.notes} onChange={set("notes")} fullWidth multiline minRows={2} variant="outlined" size="small" margin="dense" />
        <FormControlLabel
          control={<Switch checked={form.active} onChange={(e) => setForm((f) => ({ ...f, active: e.target.checked }))} color="primary" />}
          label="Ativo"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}>
          {saving ? "Salvando..." : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupplierDialog;
